import React, {Component} from 'react';
import {connect} from 'react-redux';
import { bindActionCreators } from 'redux';

import axios from "axios/index";
import {withRouter} from 'react-router-dom';
import swal from 'sweetalert2';

import urls from "../../../../utils/urls";
import {ajaxHandler} from "../../../../utils/errors";
import {tokenHeader} from "../../../../utils/headers";
import translator from "../../../../utils/translations";
import helpers from '../../../../utils/helpers';
import ToggleInput from '../../../../components/ToggleInput/toggleInput';
import { reloadTrip } from '../../../../actions/trip_actions';
import TripRejectModal from './TripRejectModal';
import formatters from "../../../../utils/formatters";

class TripDocControl extends Component {

    constructor(props) {
        super(props);

        let {trip} = props;

        this.state = {
            canEdit: helpers.canUserEditInternalTrip(props.user),
            ajaxInProgress: false,
            trip,
            truck_documentation: trip.status.id === 'E1' ? false : null,
            driver_documentation: trip.status.id === 'E1' ? false : null,
            rejection_reason: '',
            rejection_observations: '',
            openModal: false,
            edited: false
        }
    }

    _handleInput = (prop, value) => {
        // Custom validations
        this.setState({[prop]: value});
    };

    _handleToggle = (prop, value) => {
        this.setState({[prop]: value, edited: true});
    };

    _handleSelectChange = (ev) => {
        let target = ev.target;
        this.setState({
            [target.getAttribute('data-state-var')]: target.value
        });
    };

    _submitForm = () => {

        if(this.state.truck_documentation === null || this.state.driver_documentation === null){
            swal({
                title: 'Controles incompletos',
                html: 'Por favor, complete ambos controles para continuar',
                type: 'error'
            });
            return false;
        }

        if(this.state.truck_documentation === false || this.state.driver_documentation === false){
            this.setState({openModal: true});
            return false;
        }

        let data = {
            reception_documentation_control_check: true,
            next_status: 'B4'
        };

        const TRIP_URL = `${urls.API_ROOT}/api/v1/trip/id/${this.props.trip.id}/`;
        axios.put(`${TRIP_URL}`, data, tokenHeader())
            .then(this._onSubmitSuccess)
            .catch(this._onSubmitError);

    };

    _onSubmitSuccess = (response) => {
        swal({
            title: 'Viaje actualizado',
            html: 'El control ha sido ingresado correctamente. Espere unos segundos por favor',
            type: 'success',
            showConfirmButton: false,
            timer: 3000
        });

        setTimeout(this.props.reloadTrip, 3000);
    };

    _onSubmitError = (error) => {
        this.setState({ajaxInProgress: false});
        try{
            let response = error.response;
            if(response.status === 400){
                let keys = Object.keys(response.data);
                let details = '';
                for(let i in keys){
                    details = `${details} <p><b>${translator.getFieldName(keys[i])}:</b> ${response.data[keys[i]].join(' ')}</p>`;
                }
                let body = `<div class='swal-container'><p>Se han encontrado los siguientes errores: </p>${details}</div>`;
                swal({
                    title: 'No se ha podido crear el despacho',
                    html: body,
                    type: 'error'
                });
            }else{
                ajaxHandler(error);
            }
        }
        catch (e){
            ajaxHandler(error);
        }
    };

    _goBack = () => {
        if(this.state.edited){
            swal({
                title: 'Atención',
                html: helpers.texts.editionWarning,
                type: 'warning',
                showConfirmButton: true,
                showCancelButton: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
                confirmButtonText: 'Volver al inicio',
                cancelButtonText: 'Cancelar',
                preConfirm: () => this.props.history.push('/internal-trips'),
                reverseButtons: true
            });
        }else{
            this.props.history.push('/internal-trips')
        }
    };

    render() {
        let trip = this.props.trip;
        if(!trip)return <div />;

        let {truck_documentation, driver_documentation} = this.state;

        // If there's an ajax call in progress or if user can not edit
        let disableButtons = this.state.ajaxInProgress || this.state.documentation === false;
        let message = `Un viaje no puede ser ingresado si los controles de ingreso son insatisfactorios. ` +
            `Este viaje tiene que ser rechazado, por favor complete el formulario que se encuentra debajo para continuar.`;

        let controlText = 'Ingreso pendiente';
        let bannerColor = '';
        if((truck_documentation && driver_documentation) || trip.reception_documentation_control_check ){
            controlText = 'Ingreso aprobado';
            bannerColor = 'green-text';
        }else if(truck_documentation === false || driver_documentation === false){
            controlText = 'Ingreso rechazado';
            bannerColor = 'red-text';
        }

        let scaleBody = (
            <div className={"waiting-continer valign-wrapper w100"} style={{height: 150}}>
                <p className={"w100 center"}>
                    Aguardando pesaje
                    <br />
                    <i className="material-icons">more_horiz</i>
                </p>
            </div>
        );
        if(trip.entry_weight){

            let scale_in_datetime = trip.scale_in_datetime;
            if(trip.scale_in_datetime){
                scale_in_datetime = formatters.datetimeFormat(trip.scale_in_datetime);
            }

            scaleBody = (
                <div>
                    <div className={"row"}>
                        <div className={"col s6 input-field input-grey"}>
                            <label className="active">Peso Ingreso</label>
                            <p className={"field-p"}>{trip.entry_weight}</p>
                        </div>
                        <div className={"col s6 input-field input-grey"}>
                            <label className="active">Balanza</label>
                            <p className={"field-p"}>Viaje {trip.truck_scale.code}</p>
                        </div>
                    </div>
                    <div className={"row"}>
                        <div className={"col s12 input-field"}>
                            <label className="active">Fecha / Hora Ingreso</label>
                            <p className={"field-p"}>{scale_in_datetime}</p>
                        </div>
                    </div>
                </div>
            );
        }

        let canEdit = helpers.canUserEditInternalTrip(this.props.user);

        return (
            <div>
                <div className={"trip-section"}>
                    <div className={'trip-section-title'}>2. Ingreso camión</div>
                    <div className={"row no-padding thin-row trip-form"}>
                        <div className={"col s6 no-padding"}>
                            <div style={{height: 37, backgroundColor: '#d9d9d9', padding: 10}}>
                                <h4 className={'table-subtitle'}>Control de Ingreso</h4>
                            </div>
                            <div className={"row margin-top-10"}>
                                {trip.reception_documentation_control_check === false && canEdit &&
                                <div>
                                    <div className={"col s6"}>
                                        <ToggleInput
                                            selected={this.state.truck_documentation}
                                            name={'Documentación camión'} stateVar={'truck_documentation'}
                                            toggleAction={this._handleToggle}
                                        />
                                    </div>
                                    <div className={"col s6"}>
                                        <ToggleInput
                                            selected={this.state.driver_documentation}
                                            name={'Documentación chofer'} stateVar={'driver_documentation'}
                                            toggleAction={this._handleToggle}
                                        />
                                    </div>
                                </div>
                                }

                                {(trip.reception_documentation_control_check || !canEdit) &&
                                <div>
                                    <div className={"col s6"}>
                                        <ToggleInput selected={trip.reception_documentation_control_check }
                                                     name={'Documentación camión'} />
                                    </div>
                                    <div className={"col s6"}>
                                        <ToggleInput selected={trip.reception_documentation_control_check }
                                                     name={'Documentación chofer'} />
                                    </div>
                                </div>
                                }
                            </div>
                            <div className={"col s12"}>
                                <div className={`control-banner ${bannerColor}`}>
                                    {controlText}
                                </div>
                            </div>
                        </div>
                        <div className={"col s6 no-padding"}>
                            <div style={{height: 37, backgroundColor: '#d9d9d9', padding: 10}}>
                                <h4 className={'table-subtitle'}>Balanza de Ingreso</h4>
                            </div>
                            <div className={"row margin-top-10"}>
                                <div style={{borderLeft: '1px solid #404040', paddingLeft: 20}}>
                                    {scaleBody}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {(['A4', 'E1']).indexOf(trip.status.id) > -1 && canEdit &&
                <div className={"row center"}>
                    <div className={"col s12"}>
                        <button onClick={this._goBack}
                                className={`btn btn-shell-empty z-depth-0 text-center ${disableButtons ? 'disabled' : ''}`}>
                            Volver
                        </button>
                        {this.state.canEdit &&
                        <button onClick={this._submitForm}
                                className={`btn btn-shell z-depth-0 text-center ${disableButtons ? 'disabled' : ''}`}>
                            Guardar
                        </button>
                        }
                    </div>
                </div>
                }
                {this.state.openModal &&
                <TripRejectModal trip={trip} showButton={false}
                                 reloadTrip={this.props.reloadTrip}
                                 message={message}
                                 afterCloseAction={() => this.setState({openModal: false})}
                                 source={"truck_entry"} />
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user
    }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({reloadTrip}, dispatch);
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TripDocControl));



// WEBPACK FOOTER //
// ./src/containers/Dashboard/InternalTrips/Trip/TripTruckEntry.js